import axios from 'axios';
import { resolvePanelLoginUrl } from './booking';

function resolveApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'http://localhost:5000/api';
    }

    return '/api';
  }

  return 'http://localhost:5000/api';
}

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
});

// Dołącz token JWT do każdego chronionego zapytania
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bf_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Obsługa wygasłego tokenu
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isLoginRequest = requestUrl.includes('/auth/login');

    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('bf_token');
      localStorage.removeItem('bf_professional');
      window.location.href = resolvePanelLoginUrl();
    }
    return Promise.reject(error);
  }
);

export default api;
